"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/ThumbnailPicker/index.ts
var ThumbnailPicker_exports = {};
__export(ThumbnailPicker_exports, {
  ThumbnailPicker: () => ThumbnailPicker,
  ThumbnailType: () => ThumbnailType,
  useGenerateInterpolatedThumbnails: () => useGenerateInterpolatedThumbnails
});
module.exports = __toCommonJS(ThumbnailPicker_exports);

// src/components/ThumbnailPicker/ThumbnailPicker.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var import_styled = __toESM(require("@emotion/styled"));
var ThumbnailType = /* @__PURE__ */ ((ThumbnailType2) => {
  ThumbnailType2["Original"] = "original";
  ThumbnailType2["Small"] = "small";
  ThumbnailType2["Square"] = "square";
  return ThumbnailType2;
})(ThumbnailType || {});
var StyledGrid = import_styled.default.div`
  grid-template-columns: ${({ columns }) => `repeat(${columns}, minmax(0, 1fr))`};
`;
function ThumbnailPicker({
  className,
  gridClassName,
  imgClassName,
  onSelect,
  thumbnails = [],
  columns = 3,
  selected,
  type = "small" /* Small */
}) {
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    {
      className: (0, import_classnames.default)(className, [
        "v2-border v2-border-solid v2-border-neutral-200",
        "v2-bg-white v2-p-2.5 v2-justify-center v2-items-center v2-overflow-y-auto"
      ])
    },
    /* @__PURE__ */ import_react.default.createElement(
      StyledGrid,
      {
        columns,
        className: (0, import_classnames.default)(gridClassName, [
          "v2-grid v2-gap-x-1.5 v2-gap-y-1.5 v2-transition-all",
          "v2-w-fit v2-justify-center v2-items-center"
        ])
      },
      thumbnails && thumbnails.length > 0 && (thumbnails == null ? void 0 : thumbnails.map((thumbnail, index) => /* @__PURE__ */ import_react.default.createElement(
        "img",
        {
          key: index,
          className: (0, import_classnames.default)(
            imgClassName,
            [
              "v2-p-[0.187rem] hover:v2-bg-yellow-500 v2-cursor-pointer",
              "v2-transition-all max-w-full h-auto v2-animate-fade-in-150"
            ],
            {
              "v2-bg-yellow-500": index === selected
            }
          ),
          onClick: () => onSelect == null ? void 0 : onSelect(index),
          src: thumbnail[type].data,
          height: thumbnail[type].height,
          width: thumbnail[type].width
        }
      )))
    )
  );
}

// src/components/ThumbnailPicker/use-generate-interpolated-thumbnails.ts
var import_react2 = require("react");
function useGenerateInterpolatedThumbnails(thumbnails = [], thumbnailCount = 9) {
  const [interpolatedThumbnails, setInterpolatedThumbnails] = (0, import_react2.useState)([]);
  (0, import_react2.useEffect)(() => {
    if (!thumbnails || (thumbnails == null ? void 0 : thumbnails.length) === 0)
      return;
    const count = thumbnails.length;
    if (count > 0) {
      const step = count / thumbnailCount;
      const indices = Array(thumbnailCount).fill(0).map((_, i) => Math.floor(step * i));
      setInterpolatedThumbnails(indices.map((index) => thumbnails[index]));
    }
  }, [thumbnails, thumbnailCount]);
  return interpolatedThumbnails;
}
